export default "__VITE_ASSET__41260edd__"